import { createGaActionCreator } from '../../../utils';
import { CREATE_ACCOUNT_GA_CATEGORY } from '../constants';

const TRACK_NEW_PATIENT_PASSWORD_FIELD_SELECTED =
    '@@createaccountform/TRACK_NEW_FIELD_PASSWORD_FIELD_SELECT';
const TRACK_NEW_PATIENT_EMAIL_FIELD_SELECT =
    '@@createaccountform/TRACK_NEW_PATIENT_EMAIL_FIELD_SELECT';
const TRACK_NEW_PATIENT_CONFIRM_EMAIL_FIELD_SELECT =
    '@@createaccountform/TRACK_NEW_PATIENT_CONFIRM_EMAIL_FIELD_SELECT';
const TRACK_NEW_PATIENT_PASSWORD_FIELD_SELECT =
    '@@createaccountform/TRACK_NEW_PATIENT_PASSWORD_FIELD_SELECT';
const TRACK_NEW_PATIENT_DAY_DOB_FIELD_SELECT =
    '@@createaccountform/TRACK_NEW_PATIENT_DAY_DOB_FIELD_SELECT';
const TRACK_NEW_PATIENT_MONTH_DOB_FIELD_SELECT =
    '@@createaccountform/TRACK_NEW_PATIENT_MONTH_DOB_FIELD_SELECT';
const TRACK_NEW_PATIENT_YEAR_DOB_FIELD_SELECT =
    '@@createaccountform/TRACK_NEW_PATIENT_YEAR_DOB_FIELD_SELECT';
const TRACK_NEW_PATIENT_LAST_NAME_FIELD_SELECT =
    '@@createaccountform/TRACK_NEW_PATIENT_LAST_NAME_FIELD_SELECT';
const TRACK_NEW_PATIENT_FIRST_NAME_FIELD_SELECT =
    '@@createaccountform/TRACK_NEW_PATIENT_FIRST_NAME_FIELD_SELECT';
const TRACK_NEW_PATIENT_MALE_GENDER_FIELD_SELECT =
    '@@createaccountform/TRACK_NEW_PATIENT_MALE_GENDER_FIELD_SELECT';
const TRACK_NEW_PATIENT_FEMALE_GENDER_FIELD_SELECT =
    '@@createaccountform/TRACK_NEW_PATIENT_FEMALE_GENDER_FIELD_SELECT';
const TRACK_REMEMBER_ME_CHECKED =
    '@@createaccountform/TRACK_REMEMBER_ME_CHECKED';
const TRACK_REMEMBER_ME_UNCHECKED =
    '@@createaccountform/TRACK_REMEMBER_ME_UNCHECKED';
const TRACK_TERMS_OF_USE_NOT_ACCEPTED =
    '@@createaccountform/TRACK_TERMS_OF_USE_NOT_ACCEPTED';
const TRACK_TERMS_OF_USE_ACCEPTED =
    '@@createaccountform/TRACK_TERMS_OF_USE_ACCEPTED';
const TRACK_HIPAA_ACCEPTED = '@@createaccountform/TRACK_HIPAA_ACCEPTED';
const TRACK_HIPAA_NOT_ACCEPTED = '@@createaccountform/TRACK_HIPAA_NOT_ACCEPTED';
const TRACK_CLICK_SIGN_IN_LINK = '@@createaccountform/TRACK_CLICK_SIGN_IN_LINK';
const TRACK_CLICK_SUBMIT = '@@createaccountform/TRACK_CLICK_SUBMIT';
const TRACK_CLICK_EXPRESS_SUBMIT = '@@createaccountform/TRACK_CLICK_SUBMIT';
const TRACK_SCROLL_TO_HIPAA_CHECKBOX =
    '@@createaccountform/TRACK_SCROLL_TO_HIPAA_CHECKBOX';
const TRACK_SCROLL_TO_TOS_CHECKBOX =
    '@@createaccountform/TRACK_SCROLL_TO_TOS_CHECKBOX';
export const TRACK_INVALID_EMAIL_ERROR =
    '@@createaccountform/TRACK_INVALID_EMAIL_ERROR';
const TRACK_PASSWORD_ERROR = '@@createaccountform/TRACK_PASSWORD_ERROR';
export const TRACK_NAME_ERROR = '@@createaccountform/TRACK_NAME_ERROR';
export const TRACK_DATEOFBIRTH_ERROR =
    '@@createaccountform/TRACK_DATEOFBIRTH_ERROR';
const TRACK_SEX_ERROR = '@@createaccountform/TRACK_SEX_ERROR';
export const TRACK_TERMSOFSERVICE_ERROR =
    '@@createaccountform/TRACK_TERMSOFSERVICE_ERROR';
const TRACK_PASSWORD_MODAL_SHOW =
    '@@createaccountform/TRACK_PASSWORD_MODAL_SHOW';
const TRACK_PASSWORD_MODAL_CLOSE =
    '@@createaccountform/TRACK_PASSWORD_MODAL_CLOSE';
export const TRACK_EMAIL_IN_USE_ERROR =
    '@@createaccountform/TRACK_EMAIL_IN_USE_ERROR';

export const TRACK_V2_PASSWORD_ERROR =
    '@@createaccountform/TRACK_V2_PASSWORD_ERROR';

const TRACK_SIGN_IN_EMAIL_INLINE_VALIDATION =
    '@@createaccountform/TRACK_SIGNIN_EMAIL_INLINE_VALIDATION';

export const TRACK_ACCOUNT_CREATION_FAILURE =
    '@@createaccountform/TRACK_ACCOUNT_CREATION_FAILURE';

// GA Actions

export const trackAccountCreationFailure = () =>
    createGaActionCreator(
        TRACK_ACCOUNT_CREATION_FAILURE,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Account Creation Failed'
    );
export const trackNewPatientPasswordFieldSelected = () =>
    createGaActionCreator(
        TRACK_NEW_PATIENT_PASSWORD_FIELD_SELECTED,
        CREATE_ACCOUNT_GA_CATEGORY,
        'New Patient Password Field Select'
    );
export const trackNewPatientEmailFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_PATIENT_EMAIL_FIELD_SELECT,
        CREATE_ACCOUNT_GA_CATEGORY,
        'New Patient Email Field Select'
    );

export const trackNewPatientConfirmEmailFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_PATIENT_CONFIRM_EMAIL_FIELD_SELECT,
        CREATE_ACCOUNT_GA_CATEGORY,
        'New Patient Confirm Email Field Select'
    );

export const trackNewPatientPasswordFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_PATIENT_PASSWORD_FIELD_SELECT,
        CREATE_ACCOUNT_GA_CATEGORY,
        'New Patient Password Field Select'
    );

export const trackNewPatientDayDOBFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_PATIENT_DAY_DOB_FIELD_SELECT,
        CREATE_ACCOUNT_GA_CATEGORY,
        'New Patient Day DOB Field Select'
    );

export const trackNewPatientMonthDOBFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_PATIENT_MONTH_DOB_FIELD_SELECT,
        CREATE_ACCOUNT_GA_CATEGORY,
        'New Patient Month DOB Field Select'
    );

export const trackNewPatientYearDOBFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_PATIENT_YEAR_DOB_FIELD_SELECT,
        CREATE_ACCOUNT_GA_CATEGORY,
        'New Patient Year DOB Field Select'
    );

export const trackNewPatientLastNameFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_PATIENT_LAST_NAME_FIELD_SELECT,
        CREATE_ACCOUNT_GA_CATEGORY,
        'New Patient Last Name Field Select'
    );

export const trackNewPatientFirstNameFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_PATIENT_FIRST_NAME_FIELD_SELECT,
        CREATE_ACCOUNT_GA_CATEGORY,
        'New Patient First Name Field Select'
    );

export const trackNewPatientMaleGenderFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_PATIENT_MALE_GENDER_FIELD_SELECT,
        CREATE_ACCOUNT_GA_CATEGORY,
        'New Patient Male Gender Field Select'
    );

export const trackNewPatientFemaleGenderFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_PATIENT_FEMALE_GENDER_FIELD_SELECT,
        CREATE_ACCOUNT_GA_CATEGORY,
        'New Patient Female Gender Field Select'
    );

export const trackRememberMeChecked = () =>
    createGaActionCreator(
        TRACK_REMEMBER_ME_CHECKED,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Remember Me Checked'
    );

export const trackRememberMeUnchecked = () =>
    createGaActionCreator(
        TRACK_REMEMBER_ME_UNCHECKED,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Remember Me Unchecked'
    );

export const trackTermsOfUseNotAccepted = () =>
    createGaActionCreator(
        TRACK_TERMS_OF_USE_NOT_ACCEPTED,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Terms of Use Not Accepted'
    );

export const trackTermsOfUseAccepted = () =>
    createGaActionCreator(
        TRACK_TERMS_OF_USE_ACCEPTED,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Terms of Use Accepted'
    );

export const trackHipaaAccepted = () =>
    createGaActionCreator(
        TRACK_HIPAA_ACCEPTED,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Hipaa Accepted'
    );

export const trackHipaaNotAccepted = () =>
    createGaActionCreator(
        TRACK_HIPAA_NOT_ACCEPTED,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Hipaa Not Accepted'
    );

export const trackClickSignInLink = () =>
    createGaActionCreator(
        TRACK_CLICK_SIGN_IN_LINK,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Click Login Link'
    );

export const trackClickSubmit = () =>
    createGaActionCreator(
        TRACK_CLICK_SUBMIT,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Click Submit'
    );

export const trackClickExpressSubmit = () =>
    createGaActionCreator(
        TRACK_CLICK_EXPRESS_SUBMIT,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Click Express Submit'
    );

export const trackScrollToHipaaCheckbox = () =>
    createGaActionCreator(
        TRACK_SCROLL_TO_HIPAA_CHECKBOX,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Scroll To Hipaa Checkbox'
    );

export const trackScrollToTOSCheckbox = () =>
    createGaActionCreator(
        TRACK_SCROLL_TO_TOS_CHECKBOX,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Scroll To TOS Checkbox'
    );

export const trackEmailInUseError = () =>
    createGaActionCreator(
        TRACK_EMAIL_IN_USE_ERROR,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Email In Use Error'
    );

export const trackInvalidEmailError = () =>
    createGaActionCreator(
        TRACK_INVALID_EMAIL_ERROR,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Email Validation Error'
    );

export const trackPasswordError = () =>
    createGaActionCreator(
        TRACK_PASSWORD_ERROR,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Password Validation Error'
    );

export const trackNameError = () =>
    createGaActionCreator(
        TRACK_NAME_ERROR,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Name Validation Error'
    );

export const trackDateOfBirthError = () =>
    createGaActionCreator(
        TRACK_DATEOFBIRTH_ERROR,
        CREATE_ACCOUNT_GA_CATEGORY,
        'DateOfBirth Validation Error'
    );

export const trackSexError = () =>
    createGaActionCreator(
        TRACK_SEX_ERROR,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Sex Validation Error'
    );

export const trackTermsAndPrivacyError = () =>
    createGaActionCreator(
        TRACK_TERMSOFSERVICE_ERROR,
        CREATE_ACCOUNT_GA_CATEGORY,
        'TermsAndPrivacy Validation Error'
    );

export const trackPasswordModalClose = () =>
    createGaActionCreator(
        TRACK_PASSWORD_MODAL_CLOSE,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Close Password Modal'
    );

export const trackPasswordModalShow = () =>
    createGaActionCreator(
        TRACK_PASSWORD_MODAL_SHOW,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Show Password Modal'
    );

export const trackV2PasswordError = errorType =>
    createGaActionCreator(
        TRACK_V2_PASSWORD_ERROR,
        CREATE_ACCOUNT_GA_CATEGORY,
        `V2 Password Error: ${errorType}`
    );

export const trackSignInFromInlineEmailValidation = () =>
    createGaActionCreator(
        TRACK_SIGN_IN_EMAIL_INLINE_VALIDATION,
        CREATE_ACCOUNT_GA_CATEGORY,
        'Sign In Inline Email Validation'
    );

export const trackError = field => {
    switch (field) {
        case 'email':
        case 'confirmEmail':
            return trackInvalidEmailError();
        case 'birthDay':
        case 'birthYear':
        case 'birthMonth':
        case 'birthDate':
            return trackDateOfBirthError();
        case 'firstName':
        case 'lastName':
            return trackNameError();
        case 'gender':
            return trackSexError();
        case 'termsOfService':
            return trackTermsAndPrivacyError();
        case 'password':
            return trackV2PasswordError();
        default:
            return;
    }
};

export const trackFocus = field => {
    switch (field) {
        case 'firstName':
            return trackNewPatientFirstNameFieldSelect();
        case 'lastName':
            return trackNewPatientLastNameFieldSelect();
        case 'email':
            return trackNewPatientEmailFieldSelect();
        case 'confirmEmail':
            return trackNewPatientConfirmEmailFieldSelect();
        case 'birthDay':
            return trackNewPatientDayDOBFieldSelect();
        case 'birthMonth':
            return trackNewPatientMonthDOBFieldSelect();
        case 'birthYear':
            return trackNewPatientYearDOBFieldSelect();
        case 'password':
            return trackNewPatientPasswordFieldSelected();
        default:
            return;
    }
};

export const trackRadio = (field, value) => {
    switch (field) {
        case 'termsOfService':
            if (value) {
                return trackTermsOfUseAccepted();
            }
            return trackTermsOfUseNotAccepted();
        case 'gender':
            if (value === 'male') {
                return trackNewPatientMaleGenderFieldSelect();
            }
            return trackNewPatientFemaleGenderFieldSelect();
        case 'hipaa':
            if (value) {
                return trackHipaaAccepted();
            }
            return trackHipaaNotAccepted();
        case 'rememberMe':
            if (value) {
                return trackRememberMeChecked();
            }
            return trackRememberMeUnchecked();
        default:
            return;
    }
};

export const trackView = field => {
    return dispatch => {
        switch (field) {
            case 'termsOfService':
                dispatch(trackScrollToTOSCheckbox());
                break;
            case 'hipaa':
                dispatch(trackScrollToHipaaCheckbox());
                break;
            default:
                return;
        }
    };
};

export const CreateAccountTrackingActionCreators = {
    trackNewPatientEmailFieldSelect,
    trackNewPatientConfirmEmailFieldSelect,
    trackNewPatientPasswordFieldSelect,
    trackNewPatientDayDOBFieldSelect,
    trackNewPatientMonthDOBFieldSelect,
    trackNewPatientYearDOBFieldSelect,
    trackNewPatientLastNameFieldSelect,
    trackNewPatientFirstNameFieldSelect,
    trackNewPatientMaleGenderFieldSelect,
    trackNewPatientFemaleGenderFieldSelect,
    trackRememberMeChecked,
    trackRememberMeUnchecked,
    trackTermsOfUseNotAccepted,
    trackTermsOfUseAccepted,
    trackHipaaAccepted,
    trackHipaaNotAccepted,
    trackClickExpressSubmit,
    trackClickSignInLink,
    trackClickSubmit,
    trackScrollToHipaaCheckbox,
    trackScrollToTOSCheckbox,
    trackInvalidEmailError,
    trackPasswordError,
    trackNameError,
    trackDateOfBirthError,
    trackSexError,
    trackTermsAndPrivacyError,
    trackPasswordModalClose,
    trackPasswordModalShow,
    trackV2PasswordError,
    trackSignInFromInlineEmailValidation,
};
